import appSettings from '@/config/index';
import { shouldRetry } from '@/shared/utils/retry';
import type { RetryableRequestConfig } from '../../api.types';

export function shouldRetryRequest(
  originalRequest: RetryableRequestConfig,
  status?: number,
  code?: string
): boolean {
  if (!originalRequest) {
    return false;
  }

  const currentAttempt = originalRequest._retry ?? 0;
  return shouldRetry(status, code, currentAttempt, appSettings.api.retry);
}
